function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
     var ModalClose = this.querySelector('[id^="ModalClose-"]');
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, false)
      );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    //this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
          
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked
             
          )?.value;
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      //console.log('SELECT')
      
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset"
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      //console.log('INPUT')
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
     var templateSuffix = $('body').attr('suffix');
      if(templateSuffix == "base-product-without-img" || templateSuffix == "new-product" || templateSuffix == "new-product-without-image" || templateSuffix == "base-product") {
        console.log('dafdfd');
      }else{
        mediaGalleries.forEach((mediaGallery) =>
          mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            true
          )
        );
      }
   

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/*-----------------------(RJ-26/06)-----------------------------*/
$(document).ready(function () {
  var form_id = $('.quantity__input').attr('form');
  //alert(form_id);
  $(document).find('input#cstm-upload').attr('form',form_id)
  function formatDateInSpanish(dateString) {
    const months = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const days = [
        'domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'
    ];

    // Parse the input date string (format: YYYY-MM-DD)
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    // Check if the date is a weekend
    const dayIndex = date.getDay();
    if (dayIndex === 0 || dayIndex === 6) { // 0 = Sunday, 6 = Saturday
        // Move to the next Monday
        date.setDate(date.getDate() + (dayIndex === 0 ? 1 : 2));
    }

    // Format the date
    const newDayIndex = date.getDay(); // Update the day index after adjustment
    const dayNam = days[newDayIndex];
    const dayName = dayNam.substring(0, 3); // Get the first 3 letters
    const monthName = months[date.getMonth()];
    return `${dayName} ${date.getDate()} ${monthName}`;
}

// Apply the formatting to the elements
$('#dates p').each(function() {  
    const dateStr = $(this).data('date');  
    const formattedDate = formatDateInSpanish(dateStr);  
    $(this).text(formattedDate);  
});
  var future_three_days = $('div#dates p#three-days').text();
  var future_five_days = $('div#dates p#five-days').text();
  //console.log(future_three_days,'==',future_five_days)
  $('.shipping-content-wrapper span.highlighted-content.three-days').text(future_three_days);
  $('.shipping-subcontent span.highlighted-content.five-days').text(future_five_days);
  $('.shipping-content-wrapper').show();

  function selectedValue(){
     function filterTextKeepHeartOnly(text) {
          // Regular expression to match all characters, including letters, numbers, punctuation, spaces, and all heart emojis.
          const heartEmojisPattern = /[\p{L}\p{N}\p{P}\p{Zs}\n\u2764\u2763\u2765\u2795\u2796\u2665\u2666\u2663\u2660\u2661\u270D❤️🧡💛💚💙💜🖤🤍🤎💓💔💕💖💗💘💙💝💞💟]/gu;
          
          return text.match(heartEmojisPattern)?.join('') || '';
      }
   
      $(document).on("input", '.customization_start .content.tab.Lámpara .sub-tab.tab.active[id="sub-tab-1"] textarea', function () {
        var textareaText = filterTextKeepHeartOnly($(this).val());
        var lines = textareaText.split('\n');
        if (lines.length > 3) {
            lines = lines.slice(0, 3);  
            textareaText = lines.join('\n');
        }
        if (textareaText.length >= 1) {
            $(this).parent().removeClass('error');
        } else {
            $(this).parent().addClass('error');
        }
    
        $(".custom-menu-image.first .menu-content h4").html(textareaText);
        $("input#LámparaTextFirst").val(textareaText);
        $('.template-image_with_text .menu-image.image_with_text h4.texto-1').html(textareaText);
        $(this).val(textareaText); // update textarea value
    });

      
      $(document).on("input", '.customization_start .content.tab.Lámpara .sub-tab.tab.active[id="sub-tab-2"] textarea', function () {
          var textareaText = filterTextKeepHeartOnly($(this).val());
          //console.log(textareaText, 'ddd');   
          var lines = textareaText.split('\n');
          if (lines.length > 3) {
              lines = lines.slice(0, 3);  
              textareaText = lines.join('\n');
          }
          if (textareaText.length >= 1) {
              $(this).parent().removeClass('error');
          } else {
              $(this).parent().addClass('error');
          }
      
          $(".custom-menu-image.first .menu-content h5").html(textareaText);
          $("input#LámparaTextSecond").val(textareaText);
          $('.template-image_with_text .menu-image.image_with_text h4.texto-2').html(textareaText);
          $(this).val(textareaText);
      });
      
      $(document).on("input", '.customization_start .content.tab[data-id="Base"] .sub-tab.tab.active[id="sub-tab-1"] textarea', function () {
          var textareaText = filterTextKeepHeartOnly($(this).val());
          var result = textareaText.replace(/\n/g, '<br>');
          //console.log(result, '---');
          var lines = textareaText.split('\n');
          if (lines.length > 3) {
              lines = lines.slice(0, 3);  
              textareaText = lines.join('\n');
          }
          if (textareaText.length >= 1) {
              $(this).parent().removeClass('error');
          } else {
              $(this).parent().addClass('error');
          }
      
          $('.properties input#BaseTextFirst').html(result);
          $(".custom-menu-image.second .menu-content h4").html('<br>' + result);
          $("input#BaseTextFirst").val(result);
          $(this).val(textareaText);
      });
      
      $(document).on("input", '.customization_start .content.tab[data-id="Base"] .sub-tab.tab.active[id="sub-tab-2"] textarea, .customization_start .content.tab[data-id="Base"] div#sub-tab-2 textarea', function () {
          var textareaText = filterTextKeepHeartOnly($(this).val());
          //console.log(textareaText, 'dddd');     
          var lines = textareaText.split('\n');
          if (lines.length > 3) {
              lines = lines.slice(0, 3);  
              textareaText = lines.join('\n');
          }
          if (textareaText.length >= 1) {
              $(this).parent().removeClass('error');
          } else {
              $(this).parent().addClass('error');
          }
      
          if (textareaText.includes('spotify.com')) {
              $('.custom-menu-image[title=Base] .spotify-img').addClass('show');
              $('.custom-menu-image[title=Base] h5').addClass('hide');
          } else {
              $('.custom-menu-image[title=Base] .spotify-img').removeClass('show');
              $('.custom-menu-image[title=Base] h5').removeClass('hide');
          }
      
          var result = textareaText.replace(/\n/g, '<br>');
          $(".custom-menu-image.second .menu-content h5").html('<br>' + result);
          $("input#BaseTextSecond").val(textareaText);
          $(this).val(textareaText);
      });

    $(document).on("change",".customization_start div#tab-1 .file-upload input#input-63",function (e) {
        var imgURL = URL.createObjectURL(e.target.files[0]);
        var newURL = imgURL.replace("blob:", "");
        $(".custom-menu-image.first img").attr("src", imgURL);
        $(".custom-menu-image.first img").css("opacity", 1);
    });
  }
  var productActive = $(document).find(".customization_start .main_tab li").hasClass('active');
  if(productActive == true){
    $('.custom-featured_image modal-opener .product__media.media.media--transparent').hide();
   selectedValue();
  }else{
    $('.custom-featured_image modal-opener .product__media.media.media--transparent').show(); 
  }
  $(document).on("click", ".customization_start ul.main_tab li", function () {
    var id = $(this).attr("data-href");
    var dataText = $(this).attr("text");
    $(this).addClass("active").siblings().removeClass("active");    
    $('.add_to_cart_custom_itg.product-form__submit').addClass('active-btn');
    $('product-form.product-form form .product-form__buttons .product-form__submit').hide();
    $(".content.tab").each(function () {
      var tabId = $(this).attr("id");
      if (tabId == id) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });     
    $(
        ".product__media-list li.custom-featured_image.product__media-item"
      ).addClass("custom-menus-active");
      $(".custom-featured_image .custom-menu-image").each(function () {
        var dataTitle = $(this).attr("title");
        if (dataTitle == dataText) {
          //$(this).show();         
          selectedValue();
        } else {
          //$(this).hide();
        }
      });
       $('.template-new-product .custom-featured_image .custom-menu-image, .template-image_with_text .custom-featured_image .custom-menu-image, .template-new-product-without-image .custom-featured_image .custom-menu-image').each(function(){
        var imgVal = $(this).attr('itg-title');
        //alert(imgVal,'ewwe')
        if(dataText == imgVal){
          $(this).show();
          $(this).addClass('active');
        }else{
          $(this).hide();
          $(this).removeClass('active');
        }
      });
  });
  $(document).on("click",'.customization_start .content.Lámpara nav.sub_tab ul li',function () {
      var id = $(this).attr("data-href");    
      $(this).addClass("active").siblings().removeClass("active");
     
      $('.content.Lámpara .sub-tab.tab').each(function () {
        var tabId = $(this).attr("id");
        if (tabId == id) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
    }
  );
  $(document).on("click",'.customization_start .content[data-id="Base"] nav.sub_tab ul li',function () {
      var id = $(this).attr("data-href");
      $(this).addClass("active").siblings().removeClass("active");   
      
      $('.content[data-id="Base"] .sub-tab.tab').each(function () {
        var tabId = $(this).attr("id");
        if (tabId == id) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
    });
 
    // $(document).on('click','.template-new-product ul.main_tab li, .template-image_with_text ul.main_tab li ,.template-new-product-without-image ul.main_tab li', function(){
    //   var lamVal = $(this).attr('text');
    //   //console.log(lamVal,'ee');
     
    // });
  
  var imagebase64 = ""; 
$(document).on("click", ".add_to_cart_custom_itg.active-btn", function(){  
    var requiredField = $('.add_to_cart_custom_itg.active-btn').hasClass('required-field');  
    if(requiredField == true){
      var templateSuffix = $('body').attr('suffix');
      if(templateSuffix == "new-product" || templateSuffix == "new-product-without-image" || templateSuffix == "image_with_text") {
        var textareaText = $('.content.tab.Lámpara div#sub-tab-1 textarea').val();
            textareaText = textareaText.trim();
        var textareaText_two = $('.content.tab.Lámpara div#sub-tab-2 textarea').val();
            textareaText_two = textareaText_two.trim();
        var textareaText_three = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').val();
            textareaText_three = textareaText_three.trim();
        var textareaText_three_checkbox = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] input').is(':checked');
        var textareaText_four = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').val();
            textareaText_four = textareaText_four.trim();
        var textareaText_four_checkbox = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] input').is(':checked');
        var LampImage = $('.custom-menu-image.Lámpara .menu-image .new-img img').attr('src');
         console.log(textareaText_three_checkbox,'--',textareaText_four_checkbox)
        if (textareaText.length == 0) {
          //$("input#LámparaTextFirst").remove();
          $('.content.tab.Lámpara div#sub-tab-1 textarea').parent().addClass('error');
        }else{
          $('.content.tab.Lámpara div#sub-tab-1 textarea').parent().removeClass('error');
        }
        if (textareaText_two.length == 0) {
          //$("input#LámparaTextSecond").remove();
          $('.content.tab.Lámpara div#sub-tab-2 textarea').parent().addClass('error');
        }else{
          $('.content.tab.Lámpara div#sub-tab-2 textarea').parent().removeClass('error');
        }
        if (textareaText_three.length == 0 && !textareaText_three_checkbox) {
          //$("input#BaseTextFirst").remove();
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().addClass('error');
        }else{
           $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().removeClass('error');
        }
        if (textareaText_four.length == 0 && !textareaText_four_checkbox) {
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().addClass('error');
        }else{
           $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().removeClass('error');
        }
        if(textareaText.length > 0 && textareaText_two.length > 0 && LampImage){
           $(document).find('.customization_start ul.main_tab li.Lámpara').removeClass('error');
           if(textareaText_three.length == 0 && !textareaText_three_checkbox || textareaText_four.length == 0 && !textareaText_four_checkbox){
             $(document).find('.customization_start ul.main_tab li[text="Base"]').trigger('click');
            }
           // if(textareaText_three.length > 0 && textareaText_four.length > 0){
           //    $('.add_to_cart_custom_itg.active-btn').removeClass('required-field'); 
           //   document.querySelector('.add_to_cart_custom_itg.active-btn').click();
           //   $(document).find('.error-btn').addClass('hide');
           //  }
        }else{
          $(document).find('.customization_start ul.main_tab li.Lámpara').addClass('error');
          $(document).find('.error-btn').removeClass('hide');
        }
        if(textareaText_three.length == 0 && !textareaText_three_checkbox || textareaText_four.length == 0 && !textareaText_four_checkbox){
          $(document).find('.customization_start ul.main_tab li[text="Base"]').addClass('error');
          $(document).find('.error-btn').removeClass('hide');
        }else{
          $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
          if(textareaText.length == 0 || textareaText_two.length == 0 || !LampImage){
             $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').trigger('click');
          }
          if(textareaText.length > 0 && textareaText_two.length > 0 && LampImage){
            $('.add_to_cart_custom_itg.active-btn').removeClass('required-field');
            document.querySelector('.add_to_cart_custom_itg.active-btn').click();
            $(document).find('.error-btn').addClass('hide');
          }
        }

        
        // if(textareaText.length > 0 && textareaText_two.length > 0 && LampImage){
        //    $('.add_to_cart_custom_itg.active-btn').removeClass('required-field');
        //    document.querySelector('.add_to_cart_custom_itg.active-btn').click();      
        //    $(document).find('.error-btn').addClass('hide');
        // }else{
        //   $(document).find('.error-btn').removeClass('hide');
        // }
        if(textareaText.length > 0 && textareaText_two.length > 0){
          if(!LampImage){
            $('.main-quantity-selector-with-add-to-cart span.error-btn').text('seleccionar imagen');
          } 
        }else{
           $('.main-quantity-selector-with-add-to-cart span.error-btn').text('Seleccione todos los campos obligatorios');
        }
      
      }else if(templateSuffix == "base-product"){
        var textareaText_three = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').val();
            textareaText_three = textareaText_three.trim();
        var textareaText_three_checkbox = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] input').is(':checked');
        var textareaText_four = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').val();
            textareaText_four = textareaText_four.trim();
        var textareaText_four_checkbox = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] input').is(':checked');
        var baseImg = $('.custom-menu-image .itg-base-image img').attr('src');
        console.log(textareaText_three_checkbox,'--',textareaText_four_checkbox);
        // if (textareaText_three.length == 0 && textareaText_three_checkbox) {
        //   $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().addClass('error');
        // }
        if (textareaText_three.length == 0 && !textareaText_three_checkbox) {
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().addClass('error');
        }else{
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().removeClass('error');
        }
        if (textareaText_four.length == 0 && !textareaText_four_checkbox) {
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().addClass('error');
        }else{
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().removeClass('error');
        }
        if(baseImg){
          $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').removeClass('error');
          if(textareaText_three.length == 0 && !textareaText_three_checkbox || textareaText_four.length == 0 && !textareaText_four_checkbox){
             $(document).find('.customization_start ul.main_tab li[text="Base"]').trigger('click');
          }else{          
             $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
             $('.add_to_cart_custom_itg.active-btn').removeClass('required-field');
             $('.main-quantity-selector-with-add-to-cart span.error-btn').hide();        
             $('.add_to_cart_custom_itg.active-btn').trigger('click'); 
          }        
        }else{
          $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').addClass('error');
          if(textareaText_three.length == 0 && !textareaText_three_checkbox || textareaText_four.length == 0 && !textareaText_four_checkbox){
            $(document).find('.customization_start ul.main_tab li[text="Base"]').addClass('error');
          }else{
            $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
            $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').addClass('error');
            $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').trigger('click');
          }
        }
        if(textareaText_three.length > 0 && textareaText_four.length > 0){
           $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
           if(!baseImg){
             $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').trigger('click'); 
           }
        }else{
          //$(document).find('.customization_start ul.main_tab li[text="Base"]').addClass('error');
        }
        
        if(textareaText_three.length > 0 && textareaText_four.length > 0 && baseImg){
           $('.add_to_cart_custom_itg.active-btn').removeClass('required-field');
           document.querySelector('.add_to_cart_custom_itg.active-btn').click();      
           $(document).find('.error-btn').addClass('hide');
        }else{
          $(document).find('.error-btn').removeClass('hide');
        }
        if(textareaText_three.length > 0 && textareaText_four.length > 0){
          if(!baseImg){
             $('.main-quantity-selector-with-add-to-cart span.error-btn').text('seleccionar imagen');
          }
        }else{
           $('.main-quantity-selector-with-add-to-cart span.error-btn').text('Seleccione todos los campos obligatorios');
        }
      }else if(templateSuffix == "base-product-without-img"){
        var textareaText_three = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').val();
            textareaText_three = textareaText_three.trim();
        var textareaText_three_checkbox = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] input').is(':checked');
        var textareaText_four = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').val();
            textareaText_four = textareaText_four.trim();
        var textareaText_four_checkbox = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] input').is(':checked');
        if (textareaText_three.length == 0 && !textareaText_three_checkbox) {
          //$("input#BaseTextFirst").remove();
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().addClass('error');
        }else{
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().removeClass('error');
        }
        if (textareaText_four.length == 0 && !textareaText_four_checkbox) {
          //$("input#BaseTextSecond").remove(); // Corrected the id here to BaseTextSecond if the 4th textarea is related to Base
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().addClass('error');
        }else{
          $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().removeClass('error');
        }
        
        if(textareaText_three.length > 0 && textareaText_four.length > 0 || textareaText_three_checkbox && textareaText_four_checkbox){
           $('.add_to_cart_custom_itg.active-btn').removeClass('required-field');
           document.querySelector('.add_to_cart_custom_itg.active-btn').click();      
           $(document).find('.error-btn').addClass('hide');
           $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
        }else{
          $(document).find('.error-btn').removeClass('hide');
          $(document).find('.customization_start ul.main_tab li[text="Base"]').addClass('error');
        }
         if(textareaText_three.length == 0 && !textareaText_three_checkbox || textareaText_four.length == 0 && !textareaText_four_checkbox){
            $(document).find('.error-btn').removeClass('hide');
            $(document).find('.customization_start ul.main_tab li[text="Base"]').addClass('error');
         }else{
           $('.add_to_cart_custom_itg.active-btn').removeClass('required-field');
           document.querySelector('.add_to_cart_custom_itg.active-btn').click();      
           $(document).find('.error-btn').addClass('hide');
           $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
         }
         
      }      
    }else{  
    $(document).find('product-info .customization_start').addClass('itg-disabled');
    $(document).find('.add_to_cart_custom_itg').addClass('itg-disabled');
            var templateSuffix = $('body').attr('suffix');
            if(templateSuffix == "new-product" || templateSuffix == "new-product-without-image" || templateSuffix == "image_with_text") {
              var textareaText = $('.content.tab.Lámpara div#sub-tab-1 textarea').val();
                  textareaText = textareaText.trim();
              var textareaText_two = $('.content.tab.Lámpara div#sub-tab-2 textarea').val();
                  textareaText_two = textareaText_two.trim();
              var textareaText_three = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').val();
                  textareaText_three = textareaText_three.trim();
              var textareaText_four = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').val();
                  textareaText_four = textareaText_four.trim();
              if (textareaText.length == 0) {
                $("input#LámparaTextFirst").remove();
              }
              if (textareaText_two.length == 0) {
                $("input#LámparaTextSecond").remove();
              }
              if (textareaText_three.length == 0) {
                $("input#BaseTextFirst").remove();
              }
              if (textareaText_four.length == 0) {
                $("input#BaseTextSecond").remove(); // Corrected the id here to BaseTextSecond if the 4th textarea is related to Base
              }
            }
            if(templateSuffix == "base-product" || templateSuffix == "base-product-without-img"){
              var textareaText_three = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').val();
                  textareaText_three = textareaText_three.trim();
              var textareaText_four = $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').val();
                  textareaText_four = textareaText_four.trim();
              
              if (textareaText_three.length == 0) {
                $("input#BaseTextFirst").remove();
              }
              if (textareaText_four.length == 0) {
                $("input#BaseTextSecond").remove(); // Corrected the id here to BaseTextSecond if the 4th textarea is related to Base
              }
            }
              var thumbnail = document.querySelector('slider-component.thumbnail-slider');
              var thumbnailCheck = document.querySelector('media-gallery.itg-mobile-custom-slider').contains(thumbnail);
              if(thumbnailCheck){
                document.querySelector('slider-component ul.thumbnail-list li.thumbnail-list__item.index-1 button img').click(); 
              }else{
                console.log('nooo');
              }
              $("body").addClass("loading");
              var canvas_selector = $('.custom-featured_image .custom-menu-image.active').get(0);
              var dataURL = {};
              // Dynamically calculate the scale factor based on the device's pixel ratio
              var scaleFactor = Math.min(window.devicePixelRatio || 1, 1); // Use higher value for better resolution
              
              function baseCanvas(){
                 html2canvas(canvas_selector, { 
                      allowTaint: false, 
                      useCORS: true, 
                      scale: scaleFactor  
                      //backgroundColor: "#ffffff"
                  }).then(canvas => {  
                      var canvasWidth = canvas.width;
                      var canvasHeight = canvas.height;
                      $('.toCanvas').after(canvas); 
                      var img = Canvas2Image.convertToImage(canvas, canvasWidth, canvasHeight);
                      var base64_code = $(img).attr('src');
                     //console.log('base64_code',base64_code);
                      // Send image to the server
                      $.ajax({
                          type: "POST",
                          url: "https://dev.shopifyexperthelp.com/app/second_app/lightbox-mx/customization.php",
                          data: {  base64Image: base64_code },
                          beforeSend: function() {
                              $('span.add_to_cart_custom_itg.product-form__submit.active-btn .loading__spinner').removeClass('hidden');
                              $(document).find('.add_to_cart_custom_itg span.itg-btn-test').text('Agregando al carrito...');
                              $(document).find('.add_to_cart_custom_itg').addClass('itg-disabled');
                              $(document).find('product-info .customization_start').addClass('itg-disabled');
                          }
                      }).done(function(data) {
                          $("input#baseImage").val(data); 
                          $("body").removeClass("loading");
                          $('product-form.product-form form .product-form__buttons .product-form__submit').trigger('click');
                          $('span.add_to_cart_custom_itg.product-form__submit.active-btn .loading__spinner').addClass('hidden'); 
                         
                    });
                  });
              }
              
              if(templateSuffix == "base-product" || templateSuffix == "base-product-without-img"){    
                 baseCanvas();          
              }else{
                  html2canvas(canvas_selector, { 
                      allowTaint: false, 
                      useCORS: true, 
                      scale: scaleFactor  
                      //backgroundColor: "#ffffff"
                  }).then(canvas => {  
                      var canvasWidth = canvas.width;
                      var canvasHeight = canvas.height;
                      $('.toCanvas').after(canvas); 
                      var img = Canvas2Image.convertToImage(canvas, canvasWidth, canvasHeight);
                      var base64_code = $(img).attr('src');
                      //console.log(base64_code);
                      // Send image to the server
                      $.ajax({
                          type: "POST",
                          url: "https://dev.shopifyexperthelp.com/app/second_app/lightbox-mx/customization.php",
                          data: {  base64Image: base64_code },
                          beforeSend: function() {
                              $('span.add_to_cart_custom_itg.product-form__submit.active-btn .loading__spinner').removeClass('hidden');
                              $(document).find('.add_to_cart_custom_itg span.itg-btn-test').text('Agregando al carrito...');
                              $(document).find('.add_to_cart_custom_itg').addClass('itg-disabled');
                              $(document).find('product-info .customization_start').addClass('itg-disabled');
                          }
                      }).done(function(data) {
                          var navTab = $('ul.main_tab li.active').attr('data-href');  
                          if(navTab == 'tab-1'){
                            $(document).find('ul.main_tab li.active').next().trigger('click');  
                            $("input#LámparaImage").val(data);                
                          }else if(navTab == 'tab-2'){
                            $(document).find('ul.main_tab li.active').prev().trigger('click');
                             $("input#baseImage").val(data); 
                          }
                          var canvas_selector = $('.custom-featured_image .custom-menu-image.active').get(0);
                          var dataURL = {};
                          // Dynamically calculate the scale factor based on the device's pixel ratio
                          var scaleFactor = Math.min(window.devicePixelRatio || 1, 1); // Use higher value for better resolution
                      
                          html2canvas(canvas_selector, { 
                              allowTaint: false, 
                              useCORS: true, 
                              scale: scaleFactor  
                              //backgroundColor: "#ffffff"
                          }).then(canvas => {  
                              var canvasWidth = canvas.width;
                              var canvasHeight = canvas.height;
                              $('.toCanvas').after(canvas); 
                              var img = Canvas2Image.convertToImage(canvas, canvasWidth, canvasHeight);
                              var base64_code = $(img).attr('src');
                              //console.log(base64_code);
                              // Send image to the server
                              $.ajax({
                                  type: "POST",
                                  url: "https://dev.shopifyexperthelp.com/app/second_app/lightbox-mx/customization.php",
                                  data: {  base64Image: base64_code },
                                  beforeSend: function() {
                                      $('span.add_to_cart_custom_itg.product-form__submit.active-btn .loading__spinner').removeClass('hidden');
                                  }
                              }).done(function(dataSec) {
                                var navTabSec = $('ul.main_tab li.active').attr('data-href');
                                //console.log(navTabSec);
                                if(navTabSec == 'tab-1'){ 
                                  $("input#LámparaImage").val(dataSec);                
                                }else if(navTabSec == 'tab-2'){
                                   $("input#baseImage").val(dataSec); 
                                }
                                $("body").removeClass("loading");
                                $('product-form.product-form form .product-form__buttons .product-form__submit').trigger('click');
                                $('span.add_to_cart_custom_itg.product-form__submit.active-btn .loading__spinner').addClass('hidden'); 
                              });  
                                
                            }); 
                    });
                  });
               } 
    }  
});
  
  /*--------------------------------(File-upload-js)----------------------------------*/

  $(document).on('change', '.itg-desktop .main-upload-section-top input#cstm-upload', function(event) { 
    var file = event.target.files[0];
    if (file) {
        // Check if the selected file is an image .png, .jpg, .jpeg, .tiff, .webp
        if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/tiff' || file.type === 'image/webp') {
            var inputVal = URL.createObjectURL(file);
            //console.log(inputVal, '-11');
            $('.main-upload-section').removeClass('hide');
            $('.main-upload-section-top').addClass('hide');
        } else {
            alert('Please upload a PNG, JPEG, TIFF, WEBP or JPG image!');
            $(this).val(''); // Reset the file input
        }
    }
});


$(document).on('change', '.file-upload-popup.itg-desktop input#cstm-upload', function(event) {
    var file = event.target.files[0];
    if (file) {
        // Check if the selected file is a PNG image
        if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/tiff' || file.type === 'image/webp') {
            var inputVal = URL.createObjectURL(file);
            //console.log(inputVal, '-12');
            $('.main-upload-section .image-portion img').attr('src', inputVal);
            $('.main-upload-section .image-portion img').css('height', '100%');
        } else {
            alert('Please upload a PNG, JPEG, TIFF, WEBP or JPG image!');
            $(this).val(''); // Reset the file input
        }
    }
});

  if ($(window).width() > 767) {
    $(document).find('.file-upload-popup').addClass('itg-desktop');
    $(document).on('click','.file-upload button.upload-button',function(){
      $('.main-file-upload').show();
    });
    $(document).on('click','.main-file-upload .file-upload-popup .remove-icon',function(){
      $('.main-file-upload').hide();
    });
    $(document).on('click','.main-upload-section .content-portion .buttons label.confirm-btn',function(){
       $('.main-file-upload').hide();  
    });   
  }else{
     $(document).on('change', '.main-upload-section-top input#cstm-upload', function(event) { 
        var file = event.target.files[0];
        if (file) {
            // Check if the selected file is a PNG image
                var inputVal = URL.createObjectURL(file);
                //console.log(inputVal, '-11');
                $('.main-upload-section').removeClass('hide');
                $('.main-upload-section-top').addClass('hide');
             
        }
    });
    
    $(document).on('change', '.file-upload-popup input#cstm-upload', function(event) {
        var file = event.target.files[0];
        if (file) {         
                var inputVal = URL.createObjectURL(file);
                //console.log(inputVal, '-12');
                $('.main-upload-section .image-portion img').attr('src', inputVal);
                $('.main-upload-section .image-portion img').css('height', '100%');
             
        }
    });
  } 
  $(document).on('click','.main-upload-section .content-portion .buttons label.confirm-btn',function(){
    var imageSrc = $('.main-upload-section .image-portion img').attr('src');
    var imageStyle = $('.main-upload-section .image-portion img').attr('style');   
    //$('.properties input#LámparaImage2').val(imageSrc);
    $(".custom-menu-image.first img,body.template-base-product .itg-base-image img").attr("src", imageSrc);
    $(".custom-menu-image.first img,body.template-base-product .itg-base-image img").attr("style", imageStyle);
    $(".custom-menu-image.first img,body.template-base-product .itg-base-image img").css("opacity", 1);
     

  });
  let degree = 0;  
  $(document).on('click','.main-upload-section svg.feather.feather-rotate-cw',function(){         
    degree = (degree + 90) % 360; // Increments rotation by 90 degrees  
    $('#myImage').css('transform', 'rotate(' + degree + 'deg)');             
  });  
  $(document).on('click','.main-upload-section svg.feather.feather-rotate-ccw',function(){         
    degree = (degree - 90) % 360; // Increments rotation by 90 degrees  
    $('#myImage').css('transform', 'rotate(' + degree + 'deg)');             
  }); 
  let scale = 1;  
  $('.main-svg-icons svg.feather.feather-plus').click(function() {  
      scale += 0.1; // Increase zoom level  
      $('#myImage').css('transform', 'scale(' + scale + ')');  
  });    
  $('.main-svg-icons svg.feather.feather-minus').click(function() {  
      if (scale > 1) {  
          scale -= 0.1; // Decrease zoom level  
          $('#myImage').css('transform', 'scale(' + scale + ')');  
      }  
  });
  $(".content-portion .main-svg-icons .svg-icon svg.feather-chevron-up").click(function() {  
    $("#myImage").animate({top: "-=10px"}, "fast");  
  });  
  $(".content-portion .main-svg-icons .svg-icon svg.feather-chevron-down").click(function() {  
      $("#myImage").animate({top: "+=10px"}, "fast");  
  });  
  $(".content-portion .main-svg-icons .svg-icon svg.feather-chevron-left").click(function() {  
      $("#myImage").animate({left: "-=10px"}, "fast");  
  });  
  $(".content-portion .main-svg-icons .svg-icon svg.feather-chevron-right").click(function() {  
      $("#myImage").animate({left: "+=10px"}, "fast");  
  });   
  // Drag and drop
    $("#dropFiles").on('drop', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        
        // Clear previous messages and preview
        $("#messages").empty();
        $("#preview").empty(); // Ensure you have an element with id 'preview' for showing the image
        
        if (ev.originalEvent.dataTransfer && ev.originalEvent.dataTransfer.files.length) {
          var droppedFile = ev.originalEvent.dataTransfer.files[0]; // Select the first file
      
          // Check if the file is an image
          if (droppedFile && droppedFile.type.startsWith('image/')) {
            $("#messages").append("<b>Dropped File: </b>" + droppedFile.name);
            
            // Preview the image
            var reader = new FileReader();
            reader.onload = function(e) {
              var img = $('<img />', { src: e.target.result, width: '200px' });
              var img_src = e.target.result
              $('.main-upload-section .image-portion img').attr('src',img_src);
              $('.main-upload-section .image-portion img').css('height','100%');
              if(img_src){
                 $('.main-upload-section').removeClass('hide');
                 $('.main-upload-section-top').addClass('hide');
              }
            };
            reader.readAsDataURL(droppedFile);    
          } else {
            $("#messages").append("<b>Invalid File Type: </b> Only image files are allowed.");
          }
        }
        return false;
      });
      
      // Add dragover event to handle the case when files are dragged over the drop area
      $("#dropFiles").on('dragover', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        // Optional: Add a visual indicator for dragging files
      });

$('.thumbnail-list li.thumbnail-list__item').first().find('img').trigger('click');
if ($(window).width() <= 767) {
  $(document).find('.main-file-upload').addClass('mobile-popup');
  $('.main-file-upload').show();
  $(document).on('click','.file-upload button.upload-button',function(){
    $('.main-file-upload').removeClass('mobile-popup');
  });
  
  $(document).on('click','body .main-file-upload .file-upload-popup .remove-icon, .main-upload-section .content-portion .buttons label.confirm-btn',function(){
    $('.main-file-upload').show();
    $('.main-file-upload').addClass('mobile-popup');
  });
}
$(document).on('click','.thumbnail-list__item button.thumbnail',function(e){
  e.preventDefault();
  $(document).find('.product__media-list ').addClass("thumbnail-active");
});
if(navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {  
   $(document).find('.product__media-list ').addClass("sufari-thumbnail-active");  
}


var ua = navigator.userAgent.toLowerCase(); 
if (ua.indexOf('safari') != -1) { 
  if (ua.indexOf('chrome') > -1) {
    $('body').addClass('chrome');
  } else {
   $('body').addClass('safari');
  }
}
 
window.addEventListener("pageshow", function ( event ) {
  var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
  if(historyTraversal ) {
    window.location.reload();
  }
 });
 $(document).on('change','.want-to-customize-mandatory input#mandatory',function(){
   var mandatoryInput = $(this).is(':checked')
   if(mandatoryInput == true){
     $(document).find('product-info .customization_start').removeClass('hide');
     $(document).find('.add_to_cart_custom_itg').addClass('required-field');
     $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().addClass('error');
     $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().addClass('error');
     $('.main-quantity-selector-with-add-to-cart span.error-btn').show();
     $(document).find('.customization_start ul.main_tab li[text="Base"]').addClass('error');
     $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').addClass('error');  
   }else{
     $(document).find('product-info .customization_start').addClass('hide');
     $(document).find('.add_to_cart_custom_itg').removeClass('required-field');
     $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-2"] textarea').parent().removeClass('error');
     $('.content.tab[data-id="Base"] .sub-tab[id="sub-tab-1"] textarea').parent().removeClass('error');
     $('.main-quantity-selector-with-add-to-cart span.error-btn').hide();
     $(document).find('.customization_start ul.main_tab li[text="Base"]').removeClass('error');
     $(document).find('.customization_start ul.main_tab li[text="Acrílico"]').removeClass('error');
     
   }
 }); 
 $(document).on('change','.input-required input',function(){
   var inputChecked = $(this).is(':checked');
   if(inputChecked){
      $(this).parents('.second.sub-tab.tab').find('textarea').addClass('hide');
      $(this).parents('.second.sub-tab.tab').removeClass('error');
   }else{
     $(this).parents('.second.sub-tab.tab').find('textarea').removeClass('hide');
     $(this).parents('.second.sub-tab.tab').addClass('error');
   }
 }); 
});